import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import type { SourceStatusMapping, Status } from "@onetasklist/shared";
import type { StatusMappingItem } from "@onetasklist/shared/sources/statusMapping";
import { StatusMappingSection } from "./StatusMappingSection";

interface VstsColumnMappingDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  items: StatusMappingItem[];
  mappings: SourceStatusMapping[];
  boardStatuses: Status[];
  onChange: (mappings: SourceStatusMapping[]) => void;
}

export const VstsColumnMappingDialog: React.FC<VstsColumnMappingDialogProps> = ({
  open,
  onClose,
  title,
  items,
  mappings,
  boardStatuses,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onOpenChange={(_, data) => {
        if (!data.open) {
          onClose();
        }
      }}
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>
            <StatusMappingSection
              sectionNumber={0}
              variant="bare"
              items={items}
              mappings={mappings}
              boardStatuses={boardStatuses}
              onChange={onChange}
            />
          </DialogContent>
          <DialogActions fluid>
            <Button appearance="primary" onClick={onClose}>
              {t("common.actions.close")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
